export const KEYS = {
  VERSION: {
    VERSION: 'Version',
    SOFTWARE: 'Software',
    MAIN_VERSION: 'Hauptversion',
    DEPENDENCIES: 'Abhängigkeiten',
    SERVICES: 'Dienste'
  }
};
